<div class="imageViewer">
  <div>
    <dx-gallery
      #gallery
      [id]="'attrId'"
      [visible]="'true'"
      [width]="'200'"
      [height]="'200'"
      [(dataSource)]="source"
      [swipeEnabled]="true"
      [selectedIndex]="selectedIndex"
      [showIndicator]="true"
      [noDataText]="'Loading...'"
      (onContentReady)="contentReady($event)"
      (onItemClick)="itemClick($event)"
      (onItemHold)="itemHold($event)"
      (onSelectionChanged)="selectionChanged($event)"
      >
    </dx-gallery>
    <div class="gallery-actions">
      <ng-content select="[gallery-actions]"></ng-content>
    </div>
  </div>
  @if (isDataForm) {
    <div class="toolbar">
      <div fxLayout="column" fxLayoutAlign="space-around start" class="buttonsList">
        <div>
          <div
            class="toolbarItem"
            fxLayout="row"
            fxLayoutAlign="space-between center"
            style="padding-left: 10px; cursor: pointer"
            >
            <mat-icon class="buttons" svgIcon="replace_com"></mat-icon>
            <p (click)="uploadClick()" style="margin-left: 10px">Add / Replace</p>
          </div>
        </div>
        <div>
          @if (!disableDelete) {
            <div
              class="toolbarItem"
              fxLayout="row"
              fxLayoutAlign="space-between center"
              style="padding-left: 10px; cursor: pointer"
              >
              <mat-icon class="buttons" svgIcon="delete_com"></mat-icon>
              <p (click)="deleteClick()" style="margin-left: 10px">Delete</p>
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>

<div #messaegBoxContainer></div>
